import { useState, useEffect, useRef } from "react";
import InfoButton from "../InfoButton";
import InformationPopup from "../../Popups/InformationPopup";

export default function Application(props) {
    const [selected, setSelected] = useState(null);
    const [buttons, setButtons] = useState([]);
    const [clicked, setClicked] = useState(false);
    const [popupHtml, setPopupHtml] = useState(null);

    useEffect(() => {
        renderButtons();
    }, [props.applications]);

    useEffect(() => {
        if (clicked === true) {
            setTimeout(() => {
                // Submit the form
                submit();
            }, 100);
        }
    }, [selected]);

    function renderButtons() {
        const buttonsArray = Object.entries(props.applications).map(([key, value], i) => (
            <button
                className={`btn btn-option
                ${props.config.application === null && i === 0 ? "selected" : ""}
                ${props.config.application == value ? "selected" : ""}`}
                key={i}
                onClick={(e) => clickSelect(e, i)}
            >
                {value}
            </button>
        ));
        setButtons(buttonsArray);
    }

    function select(e, i) {
        // Remove selected class from all buttons
        const container = document.getElementsByClassName("application-settings-details");
        const buttons = container[0].getElementsByClassName("btn-option");
        for (var i = 0; i < buttons.length; i++) buttons[i].classList.remove("selected");
        // Add selected class to clicked button
        setSelected(e.target);
        e.target.classList.add("selected");
    }

    function clickSelect(e, i) {
        // Check if props.productSettingsExclusions is defined and contains the medical application exception

        if (
            props.productSettingsExclusions &&
            props.productSettingsExclusions.some(
                (exclusion) =>
                    exclusion.isAllowed && (exclusion.application === "Medical" || exclusion.application === "Dental")
            )
        ) {
            select(e, i);
            setClicked(true);
            return;
        }
        if (
            (e.target.innerText.toLowerCase() === "medical" || e.target.innerText.toLowerCase() === "dental") &&
            !window.localStorage.getItem("label_name")?.includes("your3dmm") &&
            !window.localStorage.getItem("label_name")?.includes("3dmedical")
        ) {
            showOceanzPopup();
            return;
        }

        select(e, i);
        setClicked(true);
    }

    function showOceanzPopup() {
        const body = document.getElementsByTagName("body")[0];
        const modalBackground = document.createElement("div");
        modalBackground.classList.add("modal-background");
        modalBackground.addEventListener("click", closeInfoPopup);
        body.appendChild(modalBackground);

        setPopupHtml(
            <InformationPopup
                content={
                    <div className="sterile-popup">
                        <button className="close-popup" onClick={closeInfoPopup}>
                            <span className="ico --close"></span>
                        </button>
                        <div className="header-img-container --no-bg">
                            <img src="/3dmedical.png" alt="3d" className="logo" />
                            <h1>Do you need 3D printed medical devices?</h1>
                            <button
                                className="popup-header-button"
                                onClick={function () {
                                    window.open("https://your3dmm.eu/", "_blank");
                                }}
                            >
                                Please go to www.your3dmm.eu
                            </button>
                        </div>
                        <div className="info-text">
                            <p>
                                Your3DMM is a new website but remains your trusted platform. Your3DMM.eu allows you to
                                easily upload and process prototypes and low-risk products.
                                <br /> For the higher-risk solutions (up to class IIa), we are happy to help you on our
                                other platform (more information:{" "}
                                <a href="mailto:r.groeneveld@3dmedicalmodels.nl">r.groeneveld@3dmedicalmodels.nl</a>).
                                <br /> Your3DMM for customers who are active in the medical market. The new software
                                platform is a great and important step forward in the further validation of the medical
                                process to jointly better comply with legislation, future requirements and developments
                                in medical care.
                            </p>
                            <br />
                            <p>
                                3D Medical Models is the partner company of Oceanz and your trusted partner for
                                high-quality 3D printed medical products, according to ISO13485.
                                <br /> Besides 3D printing we can support you to set up the technical files, CE
                                certification and also be the legal manufacturer if needed. Of course all services are
                                compliant to the Medical Device Regulation (MDR). We appreciate your feedback if there
                                are any questions or improvements.
                                <br /> We look forward to see you on the platform:{" "}
                                <a href="https://www.your3dmm.eu">www.your3dmm.eu</a>
                            </p>
                        </div>
                        <div className="popup-footer">
                            <div className="images">
                                <img src="./photo2.jpg" alt="photo1" />
                                <img src="./photo1.jpg" alt="photo2" />
                            </div>
                            <div class="contact-info">
                                <p>
                                    <span class="ico --tel"></span> <span class="value">+31(0) 852 017 406</span>
                                </p>
                                <p>
                                    <span class="ico --mail"></span>{" "}
                                    <span class="value">
                                        <a href="mailto:info@3dmedicalmodels.nl">info@3dmedicalmodels.nl</a>
                                    </span>
                                </p>
                                <p>
                                    <span class="ico --web"></span>{" "}
                                    <span class="value">
                                        <a href="http://www.3dmedicalmodels.nl" target="_blank">
                                            www.3dmedicalmodels.nl
                                        </a>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                }
            />
        );
    }

    function closeInfoPopup() {
        setPopupHtml(null);
        let modals = document.getElementsByClassName("modal-background");
        if (typeof modals !== "undefined" && modals.length > 0) {
            modals[0].remove();
        }
    }

    function submit() {
        if (selected !== null) {
            props.updateSetting("application", selected.innerText);
        } else {
            // Check if there is a button with state selected
            let btn = document.getElementsByClassName("btn-option selected")[0];
            if (btn !== null && typeof btn !== "undefined") {
                props.updateSetting("application", btn.innerText);
            }
        }
        props.goNext("overview");
        props.clearSettingsThatAreNotAllowed(true, "application");
    }

    return (
        <div className="application-settings-details">
            <h1>{props.textData.title}</h1>
            <br />
            <p className="subtitle">{props.textData.subtitle}</p>
            <br />
            <h2 className="h2-info-parent">{props.textData.header}</h2>
            <InfoButton
                info={props.productSettingExplanations.filter((info) => {
                    return info.type === "application";
                })}
                textData={props.infoTextData}
            />
            <div className="application-btns">{buttons}</div>
            {props.applications !== null && props.applications.length > 0 ? "" : <p>{props.textData.not_available}</p>}
            {popupHtml}
        </div>
    );
}
